"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _noop = _interopRequireDefault(require("lodash/noop"));

var _button = _interopRequireDefault(require("@amzn/meridian-tokens/component/button"));

var _button2 = _interopRequireDefault(require("../button"));

var _functional = require("./../_utils/functional");

var _text = _interopRequireDefault(require("./../_styles/text"));

var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoize)(function (t) {
  var _buttonTokens = (0, _button["default"])(t.tokens),
      buttonSpacingInsetHorizontalMedium = _buttonTokens.buttonSpacingInsetHorizontalMedium;

  return (0, _emotion.css)((0, _text["default"])(t), {
    position: "relative",
    padding: "".concat(t("popoverSpacingInset"), "px ").concat(t("popoverSpacingInset") - buttonSpacingInsetHorizontalMedium, "px"),
    "&:before": {
      content: "''",
      position: "absolute",
      top: t("popoverSpacingInset"),
      bottom: t("popoverSpacingInset"),
      left: 0,
      width: t("presetsDividerWidth"),
      backgroundColor: t("presetsDividerColor")
    },
    // Label
    "& > div": {
      marginLeft: buttonSpacingInsetHorizontalMedium
    },
    // List
    "& > ul": (0, _emotion.css)(_listReset["default"], {
      marginTop: t("popoverSpacingVertical")
    })
  });
});
/**
 * This component provides a way for users to select a date via a list of
 * presets.
 */

var DatePickerPresets = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DatePickerPresets, _React$Component);

  var _super = _createSuper(DatePickerPresets);

  function DatePickerPresets() {
    (0, _classCallCheck2["default"])(this, DatePickerPresets);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DatePickerPresets, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          label = _this$props.label,
          presets = _this$props.presets,
          onChange = _this$props.onChange,
          disabledDates = _this$props.disabledDates;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: styles(t)
      }, /*#__PURE__*/_react["default"].createElement("div", null, label), /*#__PURE__*/_react["default"].createElement("ul", null, presets.map(function (preset, index) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_button2["default"], {
          type: "link",
          onClick: function onClick() {
            return onChange(preset.value);
          },
          disabled: Array.isArray(preset.value) ? disabledDates(preset.value[0]) || disabledDates(preset.value[1]) : disabledDates(preset.value)
        }, preset.label));
      })));
    }
  }]);
  return DatePickerPresets;
}(_react["default"].Component);

(0, _defineProperty2["default"])(DatePickerPresets, "defaultProps", {
  label: "Presets",
  disabledDates: _noop["default"]
});
DatePickerPresets.propTypes = process.env.NODE_ENV !== "production" ? {
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)])
  })).isRequired,

  /**
   * This is called when the user chooses a preset. The value of the preset
   * will be passed as the first argument to the function as a string with the
   * format YYYY-MM-DD.
   */
  onChange: _propTypes["default"].func.isRequired,
  disabledDates: _propTypes["default"].func,
  label: _propTypes["default"].string,
  t: _propTypes["default"].func
} : {};
var _default = DatePickerPresets;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/date-picker/date-picker-presets.js
// module id = 864
// module chunks = 0